import React, { Component } from 'react';
import { Grid, Cell } from 'react-mdl';

export default class Landing extends Component {
  render() {
    return(
      <div style={{width: '100%', margin: 'auto'}}>
        <Grid className="landing-grid">
          <Cell col={12}>
            <img
              src="https://raw.githubusercontent.com/nkhrulev/data/master/img/portfolio/portfolio.png"
              alt="avatar"
              className="avatar-img"
              />

            <div className="banner-text">
              <h1>Full Stack Web Developer</h1>
              <hr />

              <p>html | css | js | bootstrap | angular | react | react native | vue | nodejs | express | mongodb | tsql | asp.net core | ef</p>

              <div className="social-links">

                <a href="https://www.instagram.com/nicols.co/" rel="noopener noreferrer" target="_blank">
                  <i className="fa fa-instagram" aria-hidden="true" />
                </a>

                <a href="https://github.com/nkhrulev/" rel="noopener noreferrer" target="_blank">
                  <i className="fa fa-github-square" aria-hidden="true" />
                </a>

                <a href="https://stackblitz.com/@nkhrulev" rel="noopener noreferrer" target="_blank">
                  <i className="fa fa-free-code-camp" aria-hidden="true" />
                </a>

                <a href="http://www.youtube.com/channel/UCLjDm3z5-5qzJCjk5dX92hA" rel="noopener noreferrer" target="_blank">
                  <i className="fa fa-youtube-square" aria-hidden="true" />
                </a>

              </div>
              <p />
            </div>
          </Cell>
        </Grid>
      </div>
    )
  }
}